import { useTranslation } from 'react-i18next'
import { ThumbsUp, ThumbsDown } from 'lucide-react'

interface StrengthItem {
  strength: string
  classification: string
}

interface WeaknessItem {
  weakness: string
  classification: string
}

interface PotentialStrengthsWeaknessesProps {
  strengths: StrengthItem[]
  weaknesses: WeaknessItem[]
}

export function PotentialStrengthsWeaknesses({ strengths, weaknesses }: PotentialStrengthsWeaknessesProps) {
  const { t } = useTranslation()
  const r = (key: string) => t(`amazonListing.potentialCheck.${key}`)

  if (!strengths.length && !weaknesses.length) return null

  return (
    <div className="potential-check-sw grid grid-cols-1 sm:grid-cols-2 gap-3">
      {strengths.length > 0 && (
        <div className="rounded-xl border border-green-200 dark:border-green-800/40 bg-green-50/50 dark:bg-green-900/10 p-4">
          <h3 className="flex items-center gap-2 text-sm font-semibold text-green-700 dark:text-green-400 mb-3">
            <ThumbsUp className="w-4 h-4" aria-hidden="true" />
            {r('topStrengths')}
          </h3>
          <ul className="space-y-2">
            {strengths.map((s, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-neutral-800 dark:text-neutral-200">
                <span className="text-green-500 mt-0.5" aria-hidden="true">•</span>
                <span>{s.strength}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {weaknesses.length > 0 && (
        <div className="rounded-xl border border-red-200 dark:border-red-800/40 bg-red-50/50 dark:bg-red-900/10 p-4">
          <h3 className="flex items-center gap-2 text-sm font-semibold text-red-700 dark:text-red-400 mb-3">
            <ThumbsDown className="w-4 h-4" aria-hidden="true" />
            {r('topWeaknesses')}
          </h3>
          <ul className="space-y-2">
            {weaknesses.map((w, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-neutral-800 dark:text-neutral-200">
                <span className="text-red-500 mt-0.5" aria-hidden="true">•</span>
                <span>{w.weakness}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
